import { useTranslation } from 'react-i18next';

export default function Market() {
  const { t } = useTranslation();

  const targets = [
    { icon: 'ri-restaurant-line', key: 'market_target0' },
    { icon: 'ri-building-line', key: 'market_target1' },
    { icon: 'ri-store-line', key: 'market_target2' },
    { icon: 'ri-global-line', key: 'market_target3' },
  ];

  return (
    <section id="market" className="pb-16 md:pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Hero banner */}
        <div className="relative mb-12 md:mb-20 rounded-lg overflow-hidden">
          <img
            src="https://static.readdy.ai/image/17b7b4fe0c11dd66d6ca2f4f9437a472/91f4f09ee94f9a1a882c01af0dd922d7.png"
            alt="Market Expansion"
            className="w-full h-52 md:h-96 object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-8 pt-0 md:pt-4">
            <h2
              className="text-xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4 leading-tight"
              style={{ fontFamily: 'Noto Sans KR, sans-serif' }}
            >
              {t('market_hero_title')}
            </h2>
            <div className="w-10 md:w-12 h-1 bg-teal-400 mx-auto mb-3 md:mb-6"></div>
            <p
              className="text-xs md:text-base lg:text-lg text-white/85 leading-relaxed whitespace-pre-line"
              style={{ fontFamily: 'Noto Sans KR, sans-serif', wordBreak: 'keep-all' }}
            >
              {t('market_hero_sub')}
            </p>
          </div>
        </div>

        {/* Target cards */}
        <div id="partnership" className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {targets.map((target, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg p-5 md:p-8 text-center hover:shadow-lg transition-shadow duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-teal-500 rounded-full">
                <i className={`${target.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              <p
                className="text-xs md:text-base text-gray-800 font-medium leading-relaxed whitespace-pre-line"
                style={{ fontFamily: 'Noto Sans KR, sans-serif' }}
              >
                {t(target.key)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
